<template >
	
	<v-dialog slot="activator" v-model="dialog" persistent max-width="800">
        <v-btn slot="activator" icon>
        	<v-icon color="grey darken-2">add_circle_outline</v-icon>
        </v-btn>
        <v-card >
        	<v-toolbar><v-toolbar-title>
        		EDIT PROGRAMS
        	</v-toolbar-title></v-toolbar>
         	<v-card-title class="body-2" color="black">
         		<v-layout column class="pl-1 pt-2">
	         		<v-flex>
	         			<v-layout row>
	         				<v-flex xs2>Dept:</v-flex>
	         				<v-flex>{{deptPCT.deptName}}</v-flex>
	         			</v-layout>
	         		</v-flex>
	         		<v-flex>
	         			<v-layout row>
	         				<v-flex xs2>Room:</v-flex>
	         				<v-flex v-if="room">{{room.number}}</v-flex>
         				</v-layout>
         			</v-flex>
         		</v-layout>
         	</v-card-title> 
        	<v-card-text class="pb-5">
        		<v-flex >
		<v-layout row class="body-2 ml-4 mt-4 mb-2 caption">
			<v-flex xs2 class="pb-1 pl-2 mr-2 ">
			  	Code
			</v-flex>
			<v-flex xs8 class="pb-1 pl-2 mr-2 ">
				Description
			</v-flex>
			<v-flex xs1 class="pb-1 pl-2 mr-2   ">
				PCT
			</v-flex>
			<v-flex xs1 class="pb-1 px-2"></v-flex>				
				
		</v-layout>
		<v-divider></v-divider>
		<v-list class="programList ml-2 mt-3" dense >

			<v-list-tile v-if="room" v-for="(item, index) in newPrograms" 
				:key="index"
				class="programListTile">
				
				<v-layout row>
					<v-flex xs2 class="mr-2">						
					  	<v-text-field 
					  		class="body-1"                         
	                        v-model="item.programID"
	                        label="Program Code"
	                        single-line  
	                        readonly 
	                        flat solo   
	                        hide-details                    
	                        @change="changed=true">                   
	                    </v-text-field>
					</v-flex>
					<v-flex xs8 class="mr-2">
						<v-autocomplete
							:items="programlist"
							@input="changed=true"
							item-text="nameAndID"
							item-value="programID"
							v-model="item.programID"
							cache-items
							class="body-1"
							flat solo
							single-line
							hide-no-data
							hide-details
							label="Program"							
						></v-autocomplete>
					</v-flex>
					<v-flex xs1 class="mr-2">
						<v-text-field 
							reverse
							class="body-1"        
	                        v-model="item.percentage"
	                        label="Program Code"
	                        single-line  
	                        flat solo  
	                        hide-details                      
	                        @change="changed=true">                  
	                    </v-text-field>
					</v-flex>

					<v-flex xs1 class="px-2 text-xs-right" style="margin-top: 10px !important;">
						<v-tooltip top>		              				                
			                <v-icon small slot="activator" @click="deleteProgram(index)" color="red lighten-2">close</v-icon>          
				            <span>Delete</span>
			            </v-tooltip>
					</v-flex>


				</v-layout>
			</v-list-tile>
		</v-list>
		<v-flex class="ml-3"><v-btn icon @click="programAddLine" ><v-icon color="grey darken-2">add</v-icon></v-btn></v-flex>
		
	</v-flex>
			</v-card-text>
        	<v-card-actions>
        		<span class="caption" style="margin-left:40px;">Programs will be replaced with what is shown</span>
	          	<v-spacer></v-spacer>
	          	<v-btn color="green darken-1" flat @click.native="dialog=false">Cancel</v-btn>
	          	<v-btn color="green darken-1" flat @click.native="programApply">Apply
	      	 	 </v-btn>
	        </v-card-actions>
    	</v-card>
    </v-dialog>
    
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

export default {
	data: () => ({
		employee: null,
		checkbox: false,
		loading: false,
		items: [],
		search: null,
		select: null,
		dialog: false,
		newPrograms: 	[],
		newProgram:{	percentage: null, 
						programID: null, 
					},
	}),

	props: [ "deptPCT", ],

	watch: {
		// When dialog opens set programs to the existing programs in the room
		// If there are no programs, add a blank line to the control
		dialog(val) {
			if (val==true) {
				this.newPrograms = [...this.deptPCT.program]
				
				if (this.newPrograms.length == 0) {
					this.programAddLine()
				}
			}
		}
	},

	computed: {
		...mapState(	{ 	room: 			state => state.space.selectedRoom, 
							programlist:   	state => state.lists.programs,
							blankProgram: 	state => state.dv.blankProgram,
						}),
		
		

/*		programs: function () {
			return this.deptPCT.program && this.deptPCT.program.length > 0 ? this.deptPCT.program : [{...this.blankProgram}]
		},*/
	},

	methods: {
		...mapMutations([	'setSnackText',						]),
		...mapActions(	[ 	'bulkProgram',						]),

		programAddLine: function () {
	    	this.newPrograms.push({...this.newProgram})
	    },

	    deleteProgram: function (index) {
	    	console.log("Delete", index)
	    	console.log(this.newPrograms)
	    	this.$delete(this.newPrograms, index)
	    	console.log(this.newPrograms)
	    },

		programApply: function() {

			//Clear any of the blank lines
			const payloadPrograms = this.newPrograms.filter((program) => program.programID)
	    	
	    	const payload = { 'roomKeyArray' : [this.room.roomKey],  // Array of one in this case
	    					'programs': payloadPrograms
	    				  }
	    	
	    	console.log(payload)
	    	
			this.bulkProgram(payload).then((response) => {
	    		this.setSnackText(response)
	    		if (!response.includes("Not Saved")) {
	    			this.dialog = false
	    			this.$emit('refresh', true)
	    		}

	    	})
	    },


	}
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/forms/ApplyProgramsDialog.vue